<div class="copyright">© Copyright {{ currentYear }}
 
 Ariadne Solutions. All Rights Reserved.</div>
<div class="version">Version 1.1.0</div>
